(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableMobileMenu =  function (){

    var menuEl = document.querySelector("#main-menu");
    if (!menuEl) {
      return;
    }

    // Initialize mmenu-light with a media query for mobile/tablet breakpoints
    var menu = new MmenuLight(menuEl, "(max-width: 1024px)");

    // Enable sliding navigation panel
    var navigator = menu.navigation({
      title: "Menu",
      slidingSubmenus: true,
      theme: "light"
    });

    // Enable off-canvas drawer on the right side
    var drawer = menu.offcanvas({
      position: "right"
    });

    var $userHelp = $(".b-user-helper__help a"),
        $userLang = $(".b-user-helper__langs a"),
        $userLogin = $(".b-user-helper__icon--logged a");

    $("#js-hamburger-button").on("click", function() {
       drawer.open();
    });

    /* se il div non esiste da errore, è da controllare dato che non sono caricati sempre tutti i blocchi dell header */
    if(typeof $userHelp !== 'undefined' && $userHelp.length > 0){
      $userHelp.on("click", function() {
        $('html,body').animate({scrollTop: 0});
        drawer.close();
      });
    }
    if(typeof $userLang !== 'undefined' && $userLang.length > 0){
      $userLang.on("click", function() {
        $('html,body').animate({scrollTop: 0});
        drawer.close();
      });
    }
    if(typeof $userLogin !== 'undefined' && $userLogin.length > 0){
      $userLogin.on("click", function() {
        $('html,body').animate({scrollTop: 0});
        drawer.close();
      });
    }
  };
})(jQuery);
